import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { BsFillLightningFill } from "react-icons/bs";
import { addToCart, skuSelector } from "../../../../redux/cart";
import { isValidUrl } from "../../../../helpers/isValidUrl";
import QuantityControls from "../../../QuantityControls/QuantityControls";
import ImageModal from "../../../ui/Modal/ImageModal/ImageModal";
import AverageSellingPriceModal from "../../../ui/Modal/averageSellingPriceModal/AverageSellingPriceModal";
import MechanicBasedView from "../../../MechanicBasedView";
import SkuPriceTiering from "../../../sku/SkuPriceTiering";
import logo from "../../../../assets/images/logo.png";
import RequestQuantityModal from "../../../ui/Modal/requestQuantity/RequestQuantityModal";
import AlternativesModal from "../../../ui/Modal/AlternativesModal/AlternativesModal";
import RelevantsModal from "../../../ui/Modal/RelevantsModal/RelevantsModal";
import RequestRepricingModal from "../../../ui/Modal/RequestRepricingModal/RequestRepricingModal";
import PackageIcon from "../../../../ui/PackageIcon";
import CartIcon from "../../../../ui/CartIcon";
import WatermarkImage from "../../../WatermarkImage";

const ProductCard = (props) => {
  const { sku } = props;

  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [averageSellingPriceModalShown, setAverageSellingPriceModalShown] =
    useState(false);

  const [showRequestQuantityModal, setShowRequestQuantityModal] =
    useState(false);
  const [showAlternativesModal, setShowAlternativesModal] = useState(false);
  const [showRelevantsModal, setShowRelevantsModal] = useState(false);
  const [showRepricingModal, setShowRepricingModal] = useState(false);

  const handleCloseRequestQuantity = () => {
    setShowRequestQuantityModal(false);
  };

  const handleShowAlternatives = () => {
    setShowAlternativesModal(true);
  };

  const handleCloseAlternatives = () => {
    setShowAlternativesModal(false);
  };

  const handleShowRelevants = () => {
    setShowRelevantsModal(true);
  };

  const handleCloseRelevants = () => {
    setShowRelevantsModal(false);
  };

  const handleOpenRequestQuantity = () => {
    setShowRequestQuantityModal(true);
  };

  const handleShowRepricing = () => {
    setShowRepricingModal(true);
  };

  const handleCloseRepricing = () => {
    setShowRepricingModal(false);
  };

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const cartSku = useSelector((state) => skuSelector(state, sku.id));

  const skuAddedToCartHandler = (sku) => {
    const skuToAdd = {
      ...sku,
      availableQuantity: sku.quantity,
    };
    skuToAdd.quantity = 1;
    dispatch(addToCart(skuToAdd));
  };

  const skuImageClickedHandler = () => {
    setImageModalVisible(true);
  };
  const imageModalClosedHandler = () => {
    setImageModalVisible(false);
  };

  const openAverageSellingPrice = () => {
    setAverageSellingPriceModalShown(true);
  };

  const closeAverageSellingPrice = () => {
    setAverageSellingPriceModalShown(false);
  };

  return (
    <article
      className={classNames(
        "border border-light-gray rounded-lg p-4 flex flex-col item-center gap-8",
        { "bg-[#F2F4F7]": !sku.quantity }
      )}
      style={{ height: "100%" }}
    >
      <div className="relative flex justify-center items-center h-40">
        {sku.isFast && (!cartSku || cartSku.quantity <= sku.fastQuantity) && (
          <div className="absolute top-2 left-0 bg-orange-500 text-white px-2 py-1 rounded-md text-xs font-bold flex items-center gap-1 z-10">
            <BsFillLightningFill className="text-yellow-300" />
            Fast
          </div>
        )}
        <button
          onClick={handleShowRepricing}
          className="absolute top-2 right-2 bg-blue-900 hover:bg-blue-700 text-white px-2 py-1.5 rounded-md text-xs font-semibold shadow-md transition-all z-10 flex items-center gap-0.5"
          title="طلب إعادة تسعير"
        >
          <span>تسعير</span>
          <span>💰</span>
        </button>
        <img
          src={
            isValidUrl(sku.imageList[0]?.imageUrl)
              ? sku.imageList[0]?.imageUrl
              : logo
          }
          onClick={skuImageClickedHandler}
          alt={sku.commercialName}
          className="max-w-full h-full object-center object-contain rounded relative z-0"
        />
        <WatermarkImage />
      </div>
      {imageModalVisible && (
        <ImageModal
          imageSource={
            isValidUrl(sku.imageList[0]?.imageUrl)
              ? sku.imageList[0]?.imageUrl
              : logo
          }
          imageAlt={sku.commercialName}
          close={imageModalClosedHandler}
        />
      )}
      <div className="space-y-1 px-2">
        <Link
          className="block text-lg font-normal hover:text-blue-400 cursor-pointer"
          to={`/product/${sku.id}`}
          state={{ from: pathname }}
        >
          {sku.commercialName}
        </Link>
        <p className="text-sm font-normal text-#677181">{sku.skuBrand}</p>
        <p className="text-sm font-bold text-pink-900">ID: {sku.id}</p>
      </div>

      <MechanicBasedView>
        <div className="mt-auto flex justify-between items-center">
          <div className="w-2/3 text-center border-l">
            <p className="px-2 flex flex-wrap justify-between">
              <span>الكمية المتاحة</span>
              <span className="text-#216DA6 font-extrabold">
                {sku.quantity || "-"}
              </span>
            </p>
            <p className="px-2 flex flex-wrap justify-between">
              <span>سعر المخزن</span>
              <span className="text-#216DA6 font-extrabold">
                {sku.inventoryPrice || sku.suggestedSellingPrice || "-"} {"جم "}
              </span>
            </p>
          </div>
          <div className="w-1/3 text-center">
            {averageSellingPriceModalShown && (
              <AverageSellingPriceModal
                close={closeAverageSellingPrice}
                skuId={sku.id}
              />
            )}
            <p onClick={openAverageSellingPrice} className="cursor-pointer">
              سعر السوق{" "}
            </p>
            <span className="text-#216DA6 font-extrabold">
              {sku.marketPrice || "-"} {"جم "}
            </span>
          </div>
        </div>

        <SkuPriceTiering
          skuId={sku.id}
          suggestedSellingPrice={
            sku.inventoryPrice || sku.suggestedSellingPrice
          }
          skuInitNextTier={sku.nextPriceTier}
          mechanicSkuPriceTieringType={sku.skuPriceTieringType}
        />

        {/* New buttons for Alternatives and Relevants */}
        <div className="px-4 flex gap-2 justify-between">
          <button
            className="px-3 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm hover:bg-gray-200 flex-1"
            onClick={handleShowAlternatives}
          >
            منتجات بديلة
          </button>
          <button
            className="px-3 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm hover:bg-gray-200 flex-1"
            onClick={handleShowRelevants}
          >
            منتجات ذات صلة
          </button>
        </div>

        <div className="px-4 mt-auto flex justify-center">
          {cartSku ? (
            <QuantityControls product={cartSku} removeOnLessOne />
          ) : sku.isValid ? (
            <button
              className="px-4 py-3 rounded-lg bg-dark-blue text-white text-center w-full hover:opacity-70 flex gap-2 justify-center"
              onClick={() => skuAddedToCartHandler(sku)}
            >
              <CartIcon /> أضف الي العربة
            </button>
          ) : (
            <button
              className="px-4 py-3 rounded-lg bg-white color-[#344054] text-center w-full border hover:opacity-60 flex justify-center items-center gap-2"
              onClick={handleOpenRequestQuantity}
            >
              <PackageIcon color={"#000"} /> أضف إلي المنتجات المطلوبة
            </button>
          )}
        </div>

        {showRequestQuantityModal && (
          <RequestQuantityModal
            closeModal={handleCloseRequestQuantity}
            sku={sku}
          />
        )}

        {showAlternativesModal && (
          <AlternativesModal close={handleCloseAlternatives} skuId={sku.id} />
        )}

        {showRelevantsModal && (
          <RelevantsModal close={handleCloseRelevants} skuId={sku.id} />
        )}

        {showRepricingModal && (
          <RequestRepricingModal closeModal={handleCloseRepricing} sku={sku} />
        )}
      </MechanicBasedView>
    </article>
  );
};

export default ProductCard;
